/**
 * @file Simple Tracking Pixel code. Add the URL you want to call, and the
 * component is being drawn, nicely and invisibly.
 *
 * @author Kaspar Manz <kaspar.manz@tages-anzeiger.ch>
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrackingPixel = function TrackingPixel(props) {
  return _react2.default.createElement('img', {
    src: props.url,
    style: { position: 'absolute', visibility: 'hidden' },
    width: '1',
    height: '1'
  });
};

TrackingPixel.propTypes = {
  /**
   * Source URL of the tracking pixel image to load.
   */
  url: _react2.default.PropTypes.string.isRequired
};

exports.default = TrackingPixel;


//////////////////
// WEBPACK FOOTER
// ./~/ta-react-trackingpixel/dist/index.js
// module id = 142
// module chunks = 0